(() => {
  if (customElements.get('stellar-support-dialog')) return;
  customElements.define('stellar-support-dialog', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-support-trigger]');
      if (!this.dialog?.showModal || !this.trigger) return;
      this.events = new AbortController();
      const on = (target, type, fn) => target.addEventListener(type, fn, { signal: this.events.signal });
      this.restore = () => {
        if (!this.snapshot) return;
        document.body.style.overflow = this.snapshot.overflow;
        const { x, y } = this.snapshot;
        this.snapshot = null;
        this.trigger.setAttribute('aria-expanded', 'false');
        window.scrollTo(x, y);
        if (this.trigger.isConnected) this.trigger.focus({ preventScroll: true });
      };
      on(this.trigger, 'click', event => {
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button) return;
        event.preventDefault();
        if (this.dialog.open || document.querySelector('modal-dialog[open],quick-add-modal[open],cart-drawer.active,dialog[open]')) return;
        this.snapshot = { overflow: document.body.style.overflow, x: window.scrollX, y: window.scrollY };
        try {
          this.dialog.showModal();
          document.body.style.overflow = 'hidden';
          this.trigger.setAttribute('aria-expanded', 'true');
          this.dialog.querySelector('[data-support-close]').focus({ preventScroll: true });
        } catch (error) { this.restore(); location.assign(this.trigger.href); }
      });
      on(this.dialog, 'close', this.restore);
      on(this.dialog, 'keydown', event => {
        if (event.key !== 'Tab') return;
        const items = Array.from(this.dialog.querySelectorAll('a[href],button:not([disabled]),[tabindex="0"]')).filter(item => item.getClientRects().length);
        const first = items[0], last = items[items.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && (document.activeElement === first || !this.dialog.contains(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !this.dialog.contains(document.activeElement))) { event.preventDefault(); first.focus(); }
      });
      on(this.dialog.querySelector('[data-support-close]'), 'click', () => this.dialog.close());
      on(this.dialog, 'click', event => { if (event.target === this.dialog) { const r=this.dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close(); } });
      on(window, 'pagehide', () => { if (this.dialog.open) this.dialog.close(); this.restore(); });
    }
    disconnectedCallback() { if (this.dialog?.open) this.dialog.close(); this.restore?.(); this.events?.abort(); this.events=null; }
  });
})();
